"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.sanitizeContent = sanitizeContent;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _excluded = ["content"];

var _require = require('lodash'),
    map = _require.map,
    omit = _require.omit;

function sanitizeContent(_ref) {
  var content = _ref.content,
      rest = (0, _objectWithoutPropertiesLoose2["default"])(_ref, _excluded);
  var blocks = map(content.blocks, removeRedundantTextAlignment);
  return (0, _extends2["default"])({}, rest, {
    content: (0, _extends2["default"])({}, content, {
      blocks: blocks
    })
  });
}
/*
 Removes text alignment from atomic blocks, because when atomic block is in selection range it's possible to set it's data.textAlignment prop.
 Removes left text alignment from text blocks, because it's a default value.
 */


function removeRedundantTextAlignment(block) {
  return block.type === 'atomic' ? omitTextAlignment(block) : omitLeftTextAlignment(block);
}

function omitLeftTextAlignment(block) {
  return block.data.textAlignment === 'left' ? omitTextAlignment(block) : block;
}

function omitTextAlignment(block) {
  return omit(block, 'data.textAlignment');
}